<template>
	<div>

		<!-- Loading加载 -->
		<div class="loading" v-if="isDetail">
			<van-loading size="40px" type="spinner" color="#39CCCD" vertical>
				<div class="loading-text">
					<div>页面正在加载</div>
					<div>请稍候</div>
				</div>
			</van-loading>
		</div>

		<div v-show="!isDetail" class="content">
			<div v-if="userInfo.realName && !isStatus">
				<div class="user-info">
					<img :src="userInfo.avatarUrl || 'https://xxc.51xxc.com/app/static/avatar.png'" alt="">
					<div class="user-info-name">昵称：{{ userInfo.realName }}</div>
					<div class="user-info-name">手机：{{ userInfo.phone || '未绑定' }}</div>
				</div>

				<div class="user-login">
					<div class="txt_1">学小成APP确认登录</div>
					<div class="txt_2">为保障账户安全，请确认是本人操作</div>
					<div class="user-login-btn" @click="goHome()">确认登录</div>
				</div>
			</div>

			<div v-if="isStatus" style="text-align: center;">
				<img :src="statusInfo.avatarUrl" style="width: 160px;height: 160px;margin-bottom: 50px;margin-top: 25%;" alt="">
				<div style="font-size: 28px;font-weight: 600;margin-bottom: 20px;">{{ statusInfo.title }}</div>
				<div style="font-size: 24px;font-weight: 600;color: #666;">{{ statusInfo.content }}</div>
			</div>
		</div>
	</div>
</template>

<script>
var that;
import { Toast } from 'vant';
export default {
	name: 'success',
	components: {},
	props: {},
	data() {
		return {
			isDetail: true,
			key: '',
			userInfo: {},
			isStatus: false,
			statusInfo: {}
		}
	},
	created() {
		that = this;
		that.key = this.$route.query.key || '';
		that.getUserDeail()
		setTimeout(() => {
			that.isDetail = false;
		}, 500);
	},
	methods: {
		goHome() {
			Toast.loading({
				message: '登录中',
				forbidClick: true,
				loadingType: 'circular'
			});
			this.$http.get('/app/users/wxScanLogin', {
				key: that.key
			}).then(res => {
				console.log(res)
				Toast.clear();
				that.isStatus = true;
				if (res.code == 200) {
					that.statusInfo = {
						avatarUrl: require('@/assets/ic_success.png'),
						title: '恭喜你，登录成功！',
						content: '请按其他终端的提示完成操作'
					}
				}
			}).catch(err => {
				Toast.clear()
				that.isStatus = true;
				if (err.code == 500) {
					that.statusInfo = {
						avatarUrl: require('@/assets/is_err.png'),
						title: '二维码已失效',
						content: '请刷新二维码后重新扫码！'
					}
				}
			})
		},

		getUserDeail() {
			this.$http.get('/app/users/current', {}).then(res => {
				console.log(res.data)
				document.title = '扫码登录';
				that.userInfo = res.data;
			})
		},

	}
}
</script>

<style scoped lang="less">
.user-login {
	text-align: center;
	margin: 10% auto;

	.txt_1 {
		font-size: 30px;
		font-weight: 600;
		color: #111;
	}

	.txt_2 {
		font-size: 24px;
		font-weight: 600;
		color: #666;
		margin-top: 20px
	}

	.user-login-btn {
		width: 80%;
		height: 80px;
		line-height: 80px;
		text-align: center;
		background: #07c160;
		border-radius: 100px;
		color: #fff;
		font-size: 30px;
		margin: 0 auto;
		margin-top: 50px;
	}
}

.user-info {
	margin-top: 40%;
	text-align: center;

	.user-info-name {
		font-size: 24px;
		font-weight: 500;
		margin-top: 20px;
		color: #666;
	}

	img {
		width: 120px;
		height: 120px;
		border-radius: 50%;
	}
}

.content {
	width: 100%;
	height: 100%;
	background-color: #fff;
	position: absolute;
}

.loading {
	margin: 40vh auto;
	text-align: center;

	.loading-text {
		color: #39CCCD;
		font-weight: bold;
	}
}
</style>